var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-min-sida-gubbe';
                    var viewUrl = 'gfx/sprite.svg#view-icon-min-sida-gubbe';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };